import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../api";

// The Today count for the nav badge — everything due across the system, so the
// nav answers "is there anything?" without opening anything.
//
// Polls on the same 60s cadence the actions themselves change on (a watcher
// landing an email, a meeting being accepted). Deliberately slower than the
// approvals badge's 30s: nothing here turns over in seconds, and the query joins
// every company's mail history.
const TodayContext = createContext({ total: 0, refresh: () => {} });

export function TodayProvider({ children }) {
  const [total, setTotal] = useState(0);

  const refresh = useCallback(async () => {
    try {
      const { total: n } = await api("/today");
      setTotal(n || 0);
    } catch {
      /* leave the last known count on a transient error */
    }
  }, []);

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 60000);
    return () => clearInterval(t);
  }, [refresh]);

  return <TodayContext.Provider value={{ total, refresh }}>{children}</TodayContext.Provider>;
}

export function useToday() {
  return useContext(TodayContext);
}
